import { render, staticRenderFns } from "./productMall.vue?vue&type=template&id=1ad55e3d&scoped=true"
import script from "./productMall.vue?vue&type=script&lang=js"
export * from "./productMall.vue?vue&type=script&lang=js"
import style0 from "./productMall.vue?vue&type=style&index=0&id=1ad55e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad55e3d",
  null
  
)

export default component.exports